import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { ShimmerBoxComponent } from './component/shimmer-box/shimmer-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomSelectComponent } from './component/custom-select/custom-select.component';
import { CustomCalendarHeaderComponent } from './component/custom-calendar-header/custom-calendar-header.component';
import { TransactionTypePipe } from './pipes/transaction-type.pipe';
import { TransactionStatusPipe } from './pipes/transaction-status.pipe';
import { FilterListPipe } from './pipes/filter-list.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { NgSelectModule } from '@ng-select/ng-select';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TransactionsComponent } from './component/transactions/transactions.component';
import { AdSpotViewComponent } from './component/ad-spot-view/ad-spot-view.component';
import { VideoLayerComponent } from './component/video-layer/video-layer.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { FooterComponent } from './component/footer/footer.component';
import { CampaignStatusPipe } from './pipes/campaign-status.pipe';
import { LocCampaignsDeviceComponent } from './component/loc-campaigns-device/loc-campaigns-device.component';
import { SearchNamePipe } from './pipes/search-name.pipe';
import { TimeFormatPipe } from './pipes/format.pipe';
import { HeaderNavBarComponent } from './component/header-nav-bar/header-nav-bar.component';
import { AdSpotChartComponent } from './component/ad-spot-chart/ad-spot-chart.component';
import { CustomBarGraphComponent } from './component/custom-bar-graph/custom-bar-graph.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { LoginComponent } from './component/login/login.component';
import { FormcontrolComponent } from './input/formcontrol.component';
import { GoogleplaceAutocompleteComponent } from './input/googleplace-autocomplete.component';
@NgModule({
  declarations: [
    ShimmerBoxComponent,
    CustomSelectComponent,
    CustomCalendarHeaderComponent,
    TransactionTypePipe,
    TransactionStatusPipe,
    FilterListPipe,
    AdSpotViewComponent,
    TransactionsComponent,
    VideoLayerComponent,
    FooterComponent,
    CampaignStatusPipe,
    LocCampaignsDeviceComponent,
    SearchNamePipe,
    TimeFormatPipe,
    HeaderNavBarComponent,
    CustomBarGraphComponent,
    AdSpotChartComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoginComponent,
    GoogleplaceAutocompleteComponent,
    FormcontrolComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatCheckboxModule,
    // NgSelectModule,
    MatTableModule,
    MatRadioModule,
    HighchartsChartModule,
  ],
  exports: [
    CustomSelectComponent,
    CustomCalendarHeaderComponent,
    TransactionTypePipe,
    TransactionStatusPipe,
    FilterListPipe,
    MatDatepickerModule,
    ShimmerBoxComponent,
    TransactionsComponent,
    AdSpotViewComponent,
    VideoLayerComponent,
    FooterComponent,
    CampaignStatusPipe,
    LocCampaignsDeviceComponent,
    TimeFormatPipe,
    HeaderNavBarComponent,
    CustomBarGraphComponent,
    AdSpotChartComponent,
    SearchNamePipe,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoginComponent,
    GoogleplaceAutocompleteComponent,
    FormcontrolComponent
  ],
  providers: [CurrencyPipe, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
